<div class="popup-container" [ngClass]="color === 'RED' ? 'bg-red' : 'bg-black'">


    <div *ngIf="step===1" class="step step1 clickable" (click)="predict()">
        <div class="title">PREDICT THE FLOP?</div>
        <div class="text">TAP HERE!</div>
        <button class="close-btn clickable" (click)="cancel($event)">✕</button>
    </div>

    <div *ngIf="step===2" class="step step2">
        <div class="half red-half clickable" (click)="chooseColor('RED')">
            <div class="center-wrapper">
                 <img src="assets/img/side-betting/suits/heart.webp" alt="heart" class="suit-icon left"/>
                <div class="color-text">RED</div>
                <img src="assets/img/side-betting/suits/diamond.webp" alt="diamond" class="suit-icon right"/>
            </div>
           
        </div>
        <div class="half black-half clickable" (click)="chooseColor('BLACK')">
            <div class="center-wrapper">
                <img src="assets/img/side-betting/suits/club.webp" alt="club" class="suit-icon left"/>
                <div class="color-text">BLACK</div>
                <img src="assets/img/side-betting/suits/spade.webp" alt="spade" class="suit-icon right"/>
            </div>
        </div>
    </div>

    <div *ngIf="step===3" class="step step3">
        <div class="options">
            <div *ngFor="let amount of amounts" (click)="selectAmount(amount)" class="option clickable" [class.selected]="amount===selectedAmount">
                <img [src]="currency === 'golds' ? 'assets/icon/chips/gold_chip.webp' : 'assets/img/sweep/money.webp'" alt="currency" class="currency"/>
                <div class="amount">{{ amount }}</div>
            </div>
        </div>

        <div class="buttons">
            <img src="assets/icon/close-circle-red.webp" alt="cancel" class="button clickable" (click)="cancel($event)">
            <img src="assets/icon/checkmark-circle-green.webp" alt="confirm" class="button clickable" (click)="confirm()">
        </div>
    </div>
</div>


<div *ngIf="step===3 && !closed" class="step step3">

</div>
